<template functional>
  <v-container>
    <v-row>
      <v-col
        md="8"
        xl="6"
        cols="12"
        class="offset-xl-1 pa-6"
      >
        <div class="d-flex flex-column-reverse flex-md-row">
          <div class="d-flex d-md-block justify-center mr-md-3">
            <v-skeleton-loader
              v-for="i in 3"
              type="image"
              height="48"
              width="48"
              class="d-inline-block d-md-block mb-md-3 ma-1 ma-md-0 overflow-hidden"
              :key="i"
            />
          </div>
          <div class="mb-1 min-w-0 mx-md-auto">
            <v-skeleton-loader
              type="image"
              height="300"
              width="300"
            />
          </div>
        </div>
      </v-col>
      <v-col
        md="4"
        xl="3"
        cols="12"
        style="min-height: 430px;"
        class="pa-6"
      >
        <v-skeleton-loader
          type="paragraph, paragraph, paragraph, paragraph, button"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="mx-auto">
        <v-card class="pa-6">
          <v-skeleton-loader
            type="paragraph, paragraph, paragraph, paragraph"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: 'ProductLoading'
};
</script>
